import { useJsApiLoader } from "@react-google-maps/api";

const libraries: ("drawing" | "geometry" | "places")[] = ["drawing", "geometry", "places"];

export const LoadScriptOnce = ({ children }: any) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAP_API_KEY),
    libraries,
    version: "quarterly",
  });

  if (loadError) {
    console.error("Google Maps load error:", loadError);
    return <div>Error loading Google Maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Google Maps...</div>;
  }

  return <>{children}</>;
};
